module.exports = __webpack_public_path__ + "static/media/iStock-184233907.88f36016.jpg";